<template>
  <div style="text-align:left" class="rule-con">
    <div class="rule-main">用户隐私政策协议</div>
    <h4>
      更新日期：2020年1月1日
      <br />生效日期：2020年1月1日
    </h4>
    <!-- <h4></h4> -->
    <br />
    <div
      class="quiz-rule-p"
    >“HYCAN 合创”系由合创汽车科技有限公司（以下或称“我们”，详细联系方式请见文末）提供，我们深知个人信息对用户（以下或称“您”）的重要性，我们尊重并保护您的隐私。鉴于此，我们根据相关法律法规规定，制定了本隐私政策，以帮助您了解我们将如何收集、存储、保护、使用及对外提供您的个人信息，并说明您享有的权利。</div>
    <div
      class="quiz-rule-p weight line"
    >请您在使用本产品之前认真阅读并确认充分理解本隐私政策，以便您做出适当的选择。如您使用本产品，即意味着您已阅读本隐私政策的所有条款，并且同意我们按照本隐私政策收集、使用并保护您的个人信息。如您不同意本隐私政策的部分或全部内容、或对本隐私政策内容有任何疑问，您有权立即停止使用本产品，并与我们联系（联系方式详见文末）。本隐私政策已对与您的权益具有或可能具有重大关系的条款，及对我们具有或可能具有免责或限制责任的条款，采用粗体字、下划线等方式予以标注，请您注意。</div>
    <div
      class="quiz-rule-p weight line"
    >本隐私政策已对与您的权益具有或可能具有重大关系的条款，及对我们具有或可能具有免责或限制责任的条款，采用粗体字、下划线等方式予以标注，请您注意。</div>
    <div class="quiz-rule-con">
      <div class="rule-title">一、我们如何收集和使用您的个人信息</div>
      <div
        class="quiz-rule-p"
      >个人信息是指以电子或其他方式记录的能够单独或者与其他信息结合识别特定自然人身份的各种信息。而对于本隐私政策中列示的如上个人敏感信息，为便于您在阅读时有所警觉，我们会在本隐私政策中以字体加粗、加下划线，或单独指出等突出显示的方式提示您注意。</div>
      <div
        class="quiz-rule-p weight line"
      >当您使用本产品时，我们将在如下具体产品或者服务场景中，基于实现该场景所需的目的收集您的个人信息。您并非必须向我们提供个人信息，但如果您选择不提供，我们可能无法为您提供相应的服务或者无法回应或解决您所遇到的问题。</div>
      <div class="quiz-rule-p">1、为了完成用户账户的注册</div>
      <div class="quiz-rule-p">
        当您注册成为我们的用户时，您需要提供
        <span class="weight">您的手机号码</span>，并在获取验证码后输入验证码完成登录。手机号码属于敏感信息，若您不提供这类信息，您可能无法成为我们的用户。如您仅需使用基础浏览服务，您可以选择不进行注册及提供该类信息。
      </div>
      <div class="quiz-rule-p">2、为了预订或购买产品/服务</div>
      <div class="quiz-rule-p">
        如您通过APP在我们的网上商城预定或购买我们的产品、服务过程中，我们可能会收集您的
        <span class="weight">个人身份信息、个人账户信息及办理交易所需要的其他信息，</span>包括
        <span class="weight">姓名、住址、性别、联系方式、证件类型、证件号码、银行或第三方支付账户、会员账户信息等。</span>
      </div>
      <div class="quiz-rule-p">3、为了更便利的登录</div>
      <div class="quiz-rule-p">
        为了让您更安全、便捷地使用登录服务，如您的设备和版本均支持指纹识别和面容识别功能，您可选择使用指纹登录或面容识别登录服务。您需在您的设备上录入您的指纹信息和面容信息。在您进行指纹登录或面容识别登录时，您需在您的设备上完成信息验证。
        <span
          class="weight"
        >我们仅接受验证结果，并不收集您的指纹信息或面容信息。</span>
        如您不想使用指纹验证或面容识别验证，仍可通过其他方式进行账户验证并登录。
      </div>
      <div
        class="quiz-rule-p"
      >4、 为便于向您提供客服及留言反馈功能，您需要填写并提交邮箱和手机号码信息，以便于我们与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果。</div>
      <div
        class="quiz-rule-p"
      >5、 为核实您提交的信息、资料是否准确、充分，以尽可能避免因他人冒用您的身份给您造成不必要的损失，您同意并授权我们可以自行或通过合作方对您提交或我们搜集的用户信息进行核实、验证，并对获得的核实、验证结果进行查看、收集、使用和留存等操作。</div>
      <div
        class="quiz-rule-p weight line"
      >6、为向您提供更便捷、更优质、个性化的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影响您使用核心业务功能，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：</div>
      <div class="quiz-rule-p">
        <span class="weight">（1）基于摄像头（相机）的功能：</span> 您可开启摄像头进行拍照并上传图片操作以及使用视频服务；
      </div>
      <div class="quiz-rule-p">
        <span class="weight">（2）基于相册的功能：</span> 您可从本地相册中选择图片上传，通过开启允许访问相册功能，您还可以在平台使用上传头像、发帖晒图服务；
      </div>
      <div class="quiz-rule-p">
        <span class="weight">（3）基于地理位置的功能：</span> 您可开启定位服务，以便查询车辆附近的充电服务站点、车辆定位和接受我们的紧急救援服务等；
      </div>
      <div class="quiz-rule-p">
        <span class="weight">（4）基于麦克风的功能：</span>您可选择麦克风设备来进行特定场景的语音输入与沟通（语音搜索、语音信息）或视频对话；
      </div>
      <div class="quiz-rule-p">
        <span class="weight">（5）基于电话的功能：</span> 您在使用服务的过程中遇到疑难问题时可一键拨打客服电话，开启该功能将避免您手动重复填写客服电话；
      </div>
      <div
        class="quiz-rule-p weight line"
      >请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</div>
      <div
        class="quiz-rule-p weight line"
      >请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交流互动或协议约定的方式另行向您说明信息收集的范围和目的，并征得您的同意。</div>
      <div class="quiz-rule-p weight">7、 根据相关法律法规，在以下情形中，我们收集、使用个人信息无需征得您的授权或同意：</div>
      <div class="quiz-rule-p">（1）与国家安全、国防安全直接相关的；</div>
      <div class="quiz-rule-p">（2）与公共安全、公共卫生、重大公共利益直接相关的；</div>
      <div class="quiz-rule-p">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
      <div class="quiz-rule-p">（4）出于维护您或他人的生命、财产等重大合法权益目的但又很难得到您本人同意的;</div>
      <div class="quiz-rule-p">（5）所收集的个人信息是您自行向社会公众公开的；</div>
      <div class="quiz-rule-p">（6）从合法公开披露的信息中收集个人信息；</div>
      <div class="quiz-rule-p">（7）根据您的要求签订和履行合同所必需的；</div>
      <div class="quiz-rule-p">（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</div>
      <div class="quiz-rule-p">（9）法律法规规定的其他情形。</div>
      <div class="quiz-rule-p">
        8、 您知晓并同意，在收集您的个人信息后，我们可能会通过技术手段对您的个人信息进行脱敏。
        <span
          class="weight line"
        >我们有权在不透露您个人信息的前提下使用已经脱敏的信息。</span>
      </div>
      <div
        class="quiz-rule-p"
      >9、 为了了解您的偏好、进行数据分析、改善产品服务及用户体验，及时发现并防范安全风险，为用户和合作方提供更好的服务，您同意我们有权使用诸如“Cookie”等搜集、追踪相关信息和资料。我们不会将“Cookie”用于本隐私政策所述目的之外的任何用途，同时您可以根据自己的偏好留存或删除“Cookie”。</div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title line weight">二、我们如何共享、转让、公开披露信息</div>
      <div class="quiz-rule-p weight line">1、信息共享</div>
      <div class="quiz-rule-p">
        <span class="weight line">除本隐私政策及法律法规、监管政策另有要求外，我们仅在特定情形下与我们的关联公司、供应商或合作伙伴共享您的信息。</span> 我们的供应商包括提供技术服务、电信服务、客户服务、风控及辅助验证服务、审计服务、法律服务、物流服务的机构；合作伙伴包括云端服务机构（以下将我们的关联公司、供应商及合作伙伴合称“第三方”）。
      </div>
      <div
        class="quiz-rule-p"
      >在和第三方合作需共享您的信息前，我们会进行商业上的合理的审查，评估第三方收集您的个人信息的正当性、合法性和必要性，尽商业上的合理努力督促第三方在使用您的个人信息时遵守法律法规及合作协议中约定的保密和安全措施，并且禁止用于合作协议约定外的任何其他用途。一经发现其违反协议约定将会采取有效措施乃至终止合作。</div>
      <div class="quiz-rule-p">该等情形包括：</div>
      <div class="quiz-rule-p">（1）为了向您提供或推荐服务、产品，或为了向您提供更完善的服务、产品，我们会与关联公司共享您的信息；</div>
      <div class="quiz-rule-p">（2）我们与第三方共同进行推广活动，在推广活动中所收集的全部或部分个人信息可能会与该第三方分享；</div>
      <div class="quiz-rule-p">（3）在获取您同意的情况下与我们的供应商及合作伙伴共享您的信息；</div>
      <div
        class="quiz-rule-p"
      >（4）在您违反有关法律法规、本协议、您与我们合作的第三方签署的相关协议时，向您的交易对手、我们的关联公司或合作伙伴等第三方提供，包括但不限于用于诉讼等；</div>
      <div
        class="quiz-rule-p weight line"
      >（5）只有共享您的信息，才能提供您需要的服务。某些服务需由合作伙（包括但不限于提供相关技术支持的公司、快递公司、提供奖品的公司）提供或共同提供，为了向您提供此类服务，您同意我们向第三方提供完成服务所必要的个人信息和数据。这些必要的个人信息包括您的基本信息如姓名、身份证号、住址。</div>
      <div class="quiz-rule-p">（6）在法律法规要求或允许的范围内，保护我们、我们的其他用户、我们的关联公司的合法权益、财产或安全免遭不当损害；</div>
      <div
        class="quiz-rule-p"
      >（7）根据法律法规及合理商业习惯，在我们计划与其他公司合并、被其他公司收购或进行其他资本市场活动（包括但不限于IPO、债券发行等），并因此需要接受来自其他主体的尽职调查时，我们会把您的信息提供给必要的主体，但我们会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理必要的保密措施；</div>
      <div class="quiz-rule-p">（8）为遵守适用的法律法规及监管规定或维护社会公共利益之目的。</div>
      <div class="quiz-rule-p">2、除以下情形外，我们不会将您的个人信息转让给任何公司、组织和个人：</div>
      <div class="quiz-rule-p">（1）事先获得您的明确同意或授权；</div>
      <div
        class="quiz-rule-p"
      >（2）在涉及合并、收购或破产清算等事件时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司或组织继续受本政策的约束，否则我们将要求该公司或组织重新向您征求授权或同意。</div>
      <div class="quiz-rule-p line weight">3、我们将会在以下情况下公开披露您的个人信息</div>
      <div class="quiz-rule-p">（1）根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</div>
      <div
        class="quiz-rule-p"
      >（2）根据法律法规的要求、强制性的行政执法或司法要所必须提供您个人信息的情况下，我们将会依据所要求的个人信息类型和披露方式公开披露您的个人信息。</div>
      <div
        class="quiz-rule-p line weight"
      >4、 根据相关法律法规及国家标准，在以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的授权或同意：</div>
      <div class="quiz-rule-p">（1）与国家安全、国防安全直接相关的；</div>
      <div class="quiz-rule-p">（2）与公共安全、公共卫生、重大公共利益直接相关的；</div>
      <div class="quiz-rule-p">（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
      <div class="quiz-rule-p">（4）出于维护您或他人的生命、财产等重大合法权益目的但又很难得到您本人同意的;</div>
      <div class="quiz-rule-p">（5）所收集的个人信息是您自行向社会公众公开的；</div>
      <div class="quiz-rule-p">（6）从合法公开披露的信息中收集个人信息；</div>
      <div class="quiz-rule-p">（7）根据您的要求签订和履行合同所必需的；</div>
      <div class="quiz-rule-p">（8）用于维护所提供的服务的安全稳定运行所必需的，例如：发现、处置产品或服务的故障；</div>
      <div class="quiz-rule-p">（9）法律法规规定的其他情形。</div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title weight line">三、我们如何保护和存储个人信息</div>
      <div class="quiz-rule-p weight">1、保存地域</div>
      <div
        class="quiz-rule-p"
      >您的个人信息将存储于中华人民共和国境内的服务器上，为了安全及备份的需要，我们可能将您的信息和资料储存到我们具备相应安全措施的公司的服务器上。</div>
      <div class="quiz-rule-p weight line">2、保存期限</div>
      <div
        class="quiz-rule-p weight line"
      >我们只会在达成本政策所述目的所需的最小期限内保留您的个人信息，除非法律有强制的存留要求。在确定该等最小期限时，我们会基于如下一些期限标准进行判断：</div>
      <div class="quiz-rule-p">（1）完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；</div>
      <div class="quiz-rule-p">（2）保证我们为您提供服务的安全和质量；</div>
      <div class="quiz-rule-p">（3）您另行授权同意的期限；</div>
      <div class="quiz-rule-p">（4） 可能存在的国家法律规范强制保存的期限要求。</div>
      <div class="quiz-rule-p weight line">在您的个人信息超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</div>
      <div class="quiz-rule-p">
        3、为保障您的信息安全，我们将采取各种合理的物理、电子和管理等方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于
        <span class="weight">SSL</span> 、信息加密存储、数据中心的访问控制、专用的网络通道及代理。我们对可能接触到您的信息的员工也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控相关操作情况等措施。我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失。
      </div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title weight line">四、如何管理您的个人信息</div>
      <div class="quiz-rule-p">1、 访问权和更正权</div>
      <div class="quiz-rule-p">
        除法律法规规定的例外情况，无论您何时使用我们的服务，您可通过我们的移动应用程序客户端登录账户，依此点击右下角“我的”以及左上角的“头像”后，查询访问您的个人信息（包含实名信息），并有权同时对有误的个人信息进行更新或更正。
        <span class="weight line">但出于风控和身份识别考虑或根据法律法规的规定，您可能无法修改部分初始注册信息（本人姓名和身份证号）。</span>
      </div>
      <div class="quiz-rule-p">2、 删除权</div>
      <div
        class="quiz-rule-p"
      >为保护您的个人信息，您在我们平台填写的认证信息是有时效性的，一般情况2个月后就会自动失效和清除。另外，符合以下情形，您有权向我们提出删除个人信息的请求：</div>
      <div class="quiz-rule-p">（1）如果我们违反法律法规规定，收集、使用个人信息的；</div>
      <div class="quiz-rule-p">（2）如果我们违反与您之间的约定，收集、使用个人信息的；</div>
      <div class="quiz-rule-p">（3）您主动注销了账号的（或实现匿名化处理）；</div>
      <div
        class="quiz-rule-p"
      >（4）我们违反法律法规规定或违反与您的约定向第三方共享、转让个人信息，且您要求删除的，我们将立即停止共享、转让的行为，并通知第三方及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）；</div>
      <div
        class="quiz-rule-p"
      >（5）我们违反法律法规规定或违反与您的约定，公开披露个人信息，且您要求删除的，我们将立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息（除非法律法规另有规定，或这些主体已独立获得您的授权）。</div>
      <div class="quiz-rule-p">当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</div>
      <div class="quiz-rule-p">2、 撤销权</div>
      <div
        class="quiz-rule-p"
      >您可以在您移动终端设备的【设置】功能中随时选择撤回部分或者全部授权，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。</div>
      <div class="quiz-rule-p">在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。</div>
      <div class="quiz-rule-p">2、 注销权</div>
      <div
        class="quiz-rule-p"
      >如您需注销您在我们平台上注册的账户，您可以通过：客服邮箱：400@gac-nio.com或在线客服与我们联系注销账户。为了向您提供更加便捷的注销方式，我们后续会不断优化我们的产品，并且通过页面公告向您告知。</div>
      <div
        class="quiz-rule-p"
      >为实现风控或合规目的，或为保护您的正当权益，特定情形下（例如账户下有待还款产品或相关待决纠纷）不支持您注销支付账户，请根据提示要求操作后再尝试注销。</div>
      <div class="quiz-rule-p">
        账户注销后将无法恢复使用，您在该账户内的所有信息也将无法恢复，我们将不会再收集、使用或共享与该账户相关的个人信息。
        <span>但您的身份资料信息和交易信息我们仍需按照监管要求的时间限制进行保存，且在该依法保存的时间内依法配合有权机关的查询。</span> 如您发现我们采集、使用您个人信息的行为违反法律法规规定或违反与您的约定，或您发现我们采集、储存的您的个人信息有误，您可联系我们的客服邮箱：400@gac-nio.com要求予以必要的更正或删除。
      </div>
      <div class="quiz-rule-p">5、 例外</div>
      <div class="quiz-rule-p">按照法律法规要求，在以下情形下，我们将无法响应您的请求：</div>
      <div class="quiz-rule-p">（1）与国家安全、国防安全直接相关的；</div>
      <div class="quiz-rule-p">（2）与公共安全、公共卫生、重大公共利益直接相关的；</div>
      <div class="quiz-rule-p">（3）与法院裁决或判决、或政府机关的强制性要求相关的；</div>
      <div class="quiz-rule-p">（5）响应您的请求将导致相关个人、组织的合法权益受到严重损害的。</div>
      <div class="quiz-rule-p">6、管理问题</div>
      <div
        class="quiz-rule-p"
      >我们将尽合理商业努力，满足您对于个人信息的访问、更正、删除、撤销、管理的要求。但对于无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</div>
      <div class="quiz-rule-p line weight">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。</div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title line weight">五、未成年人信息保护</div>
      <div class="quiz-rule-p">
        我们重视对未成年人个人信息的保护。根据相关法律法规的规定，如果您年龄小于18周岁，我们将不会为您提供相关产品和服务。若您是
        <span class="weight">18</span>周岁以下的未成年人，请您立即终止使用我们的产品/服务。
      </div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title line weight">六、对第三方责任的声明</div>
      <div
        class="quiz-rule-p line weight"
      >请您了解并注意，通过我们接入的第三方服务、您访问的第三方网站经营者等可能有自己的隐私权保护政策，该第三方可能会放置自己的Cookie或像素标签，且不受本政策的约束。请您与该第三方直接联系获取其隐私政策相关内容。我们尽力确保所有链接的第三方网站采用同等的个人信息保护措施，但是我们不对这些第三方网站上的活动、隐私权政策或隐私保护水平承担任何法律或其他责任。如果您发现该第三方在为您提供服务的过程中，其创建的网页或开发的应用程序存在风险，建议您终止相关操作以保护您的合法权益。</div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title">七、隐私政策的修订</div>
      <div
        class="quiz-rule-p"
      >本隐私政策将会随着我们的业务的发展进行更新，以便为您提供更好的服务。我们会通过网站或者APP发出更新版本并在生效前通过公告或以其他的方式提醒您相关内容的更新，请您及时访问以便了解最新的隐私政策。</div>
      <div class="quiz-rule-p">对于重大变更，我们还会提供更为显著的通知（包括对于某些服务，我们会通过如弹窗的方式发送通知，说明隐私政策的具体变更内容）。</div>
      <div class="quiz-rule-p">本隐私政策所指的重大变更包括但不限于：</div>
      <div class="quiz-rule-p">1、 本产品模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
      <div class="quiz-rule-p">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div>
      <div class="quiz-rule-p">3、个人信息共享、转让或公开披露的主要对象发生变化；</div>
      <div class="quiz-rule-p">4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
      <div class="quiz-rule-p">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div>
      <div class="quiz-rule-p">6、个人信息安全影响评估报告表明存在高风险时。</div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title weight">八、 如何联系我们</div>
      <div
        class="quiz-rule-p"
      >如果您有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈，我们将在15个工作日内反馈结果。我们为此建立了个人信息保护的专职部门及负责人，您可以发送邮件到电子邮箱400@gac-nio.com与其联系。或者，联系客服电话400-606-1600进行咨询。</div>
    </div>
    <div class="quiz-rule-con">
      <div class="rule-title">九、其他</div>
      <div class="quiz-rule-p">如本隐私政策的条款与个人信息相关的法律规定或监管要求存在不一致或冲突之处，应当以相关的法律规定或监管要求为准。</div>
      <div class="quiz-rule-p">
        本隐私政策的执行、解释及争议的解决均适用
        <span class="weight">中华人民共和国法律</span> 。您和我们就本隐私政策内容或其执行发生任何争议的，双方应友好协商解决；
        <span class="weight">如双方无法协商解决争议时，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案</span>。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about",
  components: {},

  data() {
    return {};
  },
  
  mounted() {
    window.location.replace('https://static.hycan.com.cn/linkurl/agreement.html?id=8');
  },

  watch: {},

  methods: {}
};
</script>

<style lang="scss">
@import "~@/common/flexible";
.rule-con {
  color: #051c2c;
  font-size: 20px;
  line-height: 48px;
  font-weight: 500;
  margin: 60px 30px;
}
.rule-main {
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  margin: 40px 0 30px;
}
.rule-title {
  font-size: 20px;
  line-height: 50px;
  font-weight: bold;
  margin-bottom: 20px;
}
.quiz-rule-con {
  margin-bottom: 40px;
}
.quiz-rule-p {
  margin-bottom: 20px;
  font-weight: normal;
  font-size: 20px;
  line-height: 48px;
}
.weight {
  font-weight: bold;
}
.line {
  text-decoration: underline;
}
.quiz-rule-content {
}
.quiz-rule-blue {
  color: $themeColor;
  display: inline;
  margin: 0 5px;
}
.quiz-rule-orange {
  color: #ee9b52;
  display: inline;
  margin: 0 5px;
}
</style>
